<template>
	<div class="relative block py-12" :class="selectedColor">
		<!-- Top wave -->
		<div class="wave-top">
			<svg
				viewBox="0 0 1440 150"
				version="1.1"
				xmlns="http://www.w3.org/2000/svg"
				preserveAspectRatio="none"
			>
				<path
					class="fill-white dark:fill-neutral-950"
					d="M0,45L60,42.5C120,40,240,35,360,50C480,65,600,100,720,97.5C840,95,960,55,1080,37.5C1200,20,1320,25,1440,37.5C1560,50,1680,70,1800,72.5C1920,75,2040,60,2160,55C2280,50,2400,55,2520,57.5C2640,60,2760,60,2880,70C3000,80,3120,100,3240,110C3360,120,3480,120,3600,115C3720,110,3840,100,3960,92.5C4080,85,4200,80,4320,70C4440,60,4560,45,4680,45C4800,45,4920,60,5040,60C5160,60,5280,45,5400,47.5C5520,50,5640,70,5760,80C5880,90,6000,90,6120,87.5C6240,85,6360,80,6480,77.5C6600,75,6720,75,6840,72.5C6960,70,7080,65,7200,60C7320,55,7440,50,7560,55C7680,60,7800,75,7920,82.5C8040,90,8160,90,8280,77.5C8400,65,8520,40,8580,27.5L8640,15L8640,150L8580,150C8520,150,8400,150,8280,150C8160,150,8040,150,7920,150C7800,150,7680,150,7560,150C7440,150,7320,150,7200,150C7080,150,6960,150,6840,150C6720,150,6600,150,6480,150C6360,150,6240,150,6120,150C6000,150,5880,150,5760,150C5640,150,5520,150,5400,150C5280,150,5160,150,5040,150C4920,150,4800,150,4680,150C4560,150,4440,150,4320,150C4200,150,4080,150,3960,150C3840,150,3720,150,3600,150C3480,150,3360,150,3240,150C3120,150,3000,150,2880,150C2760,150,2640,150,2520,150C2400,150,2280,150,2160,150C2040,150,1920,150,1800,150C1680,150,1560,150,1440,150C1320,150,1200,150,1080,150C960,150,840,150,720,150C600,150,480,150,360,150C240,150,120,150,60,150L0,150Z"
				></path>
			</svg>
			<!-- <svg
				v-else-if="top === 1"
				viewBox="0 0 1440 150"
				version="1.1"
				xmlns="http://www.w3.org/2000/svg"
				preserveAspectRatio="none"
			>
				<path
					class="fill-white dark:fill-neutral-950"
					d="M0,15L60,27.5C120,40,240,65,360,77.5C480,90,600,90,720,80C840,70,960,50,1080,35C1200,20,1320,10,1440,22.5C1560,35,1680,70,1800,82.5C1920,95,2040,85,2160,87.5C2280,90,2400,105,2520,95C2640,85,2760,50,2880,42.5C3000,35,3120,55,3240,55C3360,55,3480,35,3600,22.5C3720,10,3840,5,3960,25C4080,45,4200,90,4320,107.5C4440,125,4560,115,4680,92.5C4800,70,4920,35,5040,37.5C5160,40,5280,80,5400,82.5C5520,85,5640,50,5760,35C5880,20,6000,25,6120,25C6240,25,6360,20,6480,37.5C6600,55,6720,95,6840,100C6960,105,7080,75,7200,65C7320,55,7440,65,7560,72.5C7680,80,7800,85,7920,85C8040,85,8160,80,8280,80C8400,80,8520,85,8580,87.5L8640,90L8640,150L8580,150C8520,150,8400,150,8280,150C8160,150,8040,150,7920,150C7800,150,7680,150,7560,150C7440,150,7320,150,7200,150C7080,150,6960,150,6840,150C6720,150,6600,150,6480,150C6360,150,6240,150,6120,150C6000,150,5880,150,5760,150C5640,150,5520,150,5400,150C5280,150,5160,150,5040,150C4920,150,4800,150,4680,150C4560,150,4440,150,4320,150C4200,150,4080,150,3960,150C3840,150,3720,150,3600,150C3480,150,3360,150,3240,150C3120,150,3000,150,2880,150C2760,150,2640,150,2520,150C2400,150,2280,150,2160,150C2040,150,1920,150,1800,150C1680,150,1560,150,1440,150C1320,150,1200,150,1080,150C960,150,840,150,720,150C600,150,480,150,360,150C240,150,120,150,60,150L0,150Z"
				></path>
			</svg>
			<svg
				v-else
				viewBox="0 0 1440 150"
				version="1.1"
				xmlns="http://www.w3.org/2000/svg"
				preserveAspectRatio="none"
			>
				<path
					class="fill-white dark:fill-neutral-950"
					d="M0,120L60,102.5C120,85,240,50,360,32.5C480,15,600,15,720,22.5C840,30,960,45,1080,42.5C1200,40,1320,20,1440,17.5C1560,15,1680,30,1800,52.5C1920,75,2040,105,2160,115C2280,125,2400,115,2520,115C2640,115,2760,125,2880,117.5C3000,110,3120,85,3240,65C3360,45,3480,30,3600,27.5C3720,25,3840,35,3960,52.5C4080,70,4200,95,4320,105C4440,115,4560,110,4680,92.5C4800,75,4920,45,5040,37.5C5160,30,5280,45,5400,52.5C5520,60,5640,60,5760,62.5C5880,65,6000,70,6120,82.5C6240,95,6360,115,6480,115C6600,115,6720,95,6840,85C6960,75,7080,75,7200,72.5C7320,70,7440,65,7560,57.5C7680,50,7800,40,7920,32.5C8040,25,8160,20,8280,15C8400,10,8520,5,8580,2.5L8640,0L8640,150L8580,150C8520,150,8400,150,8280,150C8160,150,8040,150,7920,150C7800,150,7680,150,7560,150C7440,150,7320,150,7200,150C7080,150,6960,150,6840,150C6720,150,6600,150,6480,150C6360,150,6240,150,6120,150C6000,150,5880,150,5760,150C5640,150,5520,150,5400,150C5280,150,5160,150,5040,150C4920,150,4800,150,4680,150C4560,150,4440,150,4320,150C4200,150,4080,150,3960,150C3840,150,3720,150,3600,150C3480,150,3360,150,3240,150C3120,150,3000,150,2880,150C2760,150,2640,150,2520,150C2400,150,2280,150,2160,150C2040,150,1920,150,1800,150C1680,150,1560,150,1440,150C1320,150,1200,150,1080,150C960,150,840,150,720,150C600,150,480,150,360,150C240,150,120,150,60,150L0,150Z"
				></path>
			</svg> -->
		</div>
		<!-- <div class="h-80"></div> -->
		<div :class="computedHeight"></div>
		<slot />
		<div :class="computedHeight"></div>
		<!-- Bottom wave -->
		<div class="wave-bottom">
			<svg
				viewBox="0 0 1440 150"
				version="1.1"
				xmlns="http://www.w3.org/2000/svg"
				preserveAspectRatio="none"
			>
				<path
					class="fill-white dark:fill-neutral-950"
					d="M0,105L60,97.5C120,90,240,75,360,62.5C480,50,600,40,720,45C840,50,960,70,1080,75C1200,80,1320,70,1440,70C1560,70,1680,80,1800,70C1920,60,2040,30,2160,22.5C2280,15,2400,30,2520,32.5C2640,35,2760,25,2880,40C3000,55,3120,95,3240,92.5C3360,90,3480,45,3600,35C3720,25,3840,50,3960,52.5C4080,55,4200,35,4320,27.5C4440,20,4560,25,4680,42.5C4800,60,4920,90,5040,107.5C5160,125,5280,130,5400,120C5520,110,5640,85,5760,85C5880,85,6000,110,6120,110C6240,110,6360,85,6480,75C6600,65,6720,70,6840,65C6960,60,7080,45,7200,32.5C7320,20,7440,10,7560,20C7680,30,7800,60,7920,60C8040,60,8160,30,8280,20C8400,10,8520,20,8580,25L8640,30L8640,150L8580,150C8520,150,8400,150,8280,150C8160,150,8040,150,7920,150C7800,150,7680,150,7560,150C7440,150,7320,150,7200,150C7080,150,6960,150,6840,150C6720,150,6600,150,6480,150C6360,150,6240,150,6120,150C6000,150,5880,150,5760,150C5640,150,5520,150,5400,150C5280,150,5160,150,5040,150C4920,150,4800,150,4680,150C4560,150,4440,150,4320,150C4200,150,4080,150,3960,150C3840,150,3720,150,3600,150C3480,150,3360,150,3240,150C3120,150,3000,150,2880,150C2760,150,2640,150,2520,150C2400,150,2280,150,2160,150C2040,150,1920,150,1800,150C1680,150,1560,150,1440,150C1320,150,1200,150,1080,150C960,150,840,150,720,150C600,150,480,150,360,150C240,150,120,150,60,150L0,150Z"
				></path>
			</svg>
			<!-- <svg
				v-else-if="bottom === 1"
				viewBox="0 0 1440 150"
				version="1.1"
				xmlns="http://www.w3.org/2000/svg"
				preserveAspectRatio="none"
			>
				<path
					class="fill-white dark:fill-neutral-950"
					d="M0,0L60,5C120,10,240,20,360,35C480,50,600,70,720,77.5C840,85,960,80,1080,75C1200,70,1320,65,1440,70C1560,75,1680,90,1800,102.5C1920,115,2040,125,2160,117.5C2280,110,2400,85,2520,70C2640,55,2760,50,2880,42.5C3000,35,3120,25,3240,17.5C3360,10,3480,5,3600,10C3720,15,3840,30,3960,52.5C4080,75,4200,105,4320,117.5C4440,130,4560,125,4680,112.5C4800,100,4920,80,5040,72.5C5160,65,5280,70,5400,72.5C5520,75,5640,75,5760,85C5880,95,6000,115,6120,112.5C6240,110,6360,85,6480,75C6600,65,6720,70,6840,80C6960,90,7080,105,7200,112.5C7320,120,7440,120,7560,105C7680,90,7800,60,7920,50C8040,40,8160,50,8280,62.5C8400,75,8520,90,8580,97.5L8640,105L8640,150L8580,150C8520,150,8400,150,8280,150C8160,150,8040,150,7920,150C7800,150,7680,150,7560,150C7440,150,7320,150,7200,150C7080,150,6960,150,6840,150C6720,150,6600,150,6480,150C6360,150,6240,150,6120,150C6000,150,5880,150,5760,150C5640,150,5520,150,5400,150C5280,150,5160,150,5040,150C4920,150,4800,150,4680,150C4560,150,4440,150,4320,150C4200,150,4080,150,3960,150C3840,150,3720,150,3600,150C3480,150,3360,150,3240,150C3120,150,3000,150,2880,150C2760,150,2640,150,2520,150C2400,150,2280,150,2160,150C2040,150,1920,150,1800,150C1680,150,1560,150,1440,150C1320,150,1200,150,1080,150C960,150,840,150,720,150C600,150,480,150,360,150C240,150,120,150,60,150L0,150Z"
				></path>
			</svg>
			<svg
				v-else
				viewBox="0 0 1440 150"
				version="1.1"
				xmlns="http://www.w3.org/2000/svg"
				preserveAspectRatio="none"
			>
				<path
					class="fill-white dark:fill-neutral-950"
					d="M0,120L60,112.5C120,105,240,90,360,80C480,70,600,65,720,72.5C840,80,960,100,1080,102.5C1200,105,1320,90,1440,82.5C1560,75,1680,75,1800,82.5C1920,90,2040,105,2160,105C2280,105,2400,90,2520,82.5C2640,75,2760,75,2880,82.5C3000,90,3120,105,3240,107.5C3360,110,3480,100,3600,102.5C3720,105,3840,120,3960,105C4080,90,4200,45,4320,45C4440,45,4560,90,4680,95C4800,100,4920,65,5040,52.5C5160,40,5280,50,5400,50C5520,50,5640,40,5760,35C5880,30,6000,30,6120,45C6240,60,6360,90,6480,100C6600,110,6720,100,6840,97.5C6960,95,7080,100,7200,85C7320,70,7440,35,7560,17.5C7680,0,7800,0,7920,12.5C8040,25,8160,50,8280,55C8400,60,8520,45,8580,37.5L8640,30L8640,150L8580,150C8520,150,8400,150,8280,150C8160,150,8040,150,7920,150C7800,150,7680,150,7560,150C7440,150,7320,150,7200,150C7080,150,6960,150,6840,150C6720,150,6600,150,6480,150C6360,150,6240,150,6120,150C6000,150,5880,150,5760,150C5640,150,5520,150,5400,150C5280,150,5160,150,5040,150C4920,150,4800,150,4680,150C4560,150,4440,150,4320,150C4200,150,4080,150,3960,150C3840,150,3720,150,3600,150C3480,150,3360,150,3240,150C3120,150,3000,150,2880,150C2760,150,2640,150,2520,150C2400,150,2280,150,2160,150C2040,150,1920,150,1800,150C1680,150,1560,150,1440,150C1320,150,1200,150,1080,150C960,150,840,150,720,150C600,150,480,150,360,150C240,150,120,150,60,150L0,150Z"
				></path>
			</svg> -->
		</div>
	</div>
</template>

<script lang="ts" setup>
type Size = 'sm' | 'md' | 'lg' | 'xl'

const props = withDefaults(
	defineProps<{
		backgroundColor?: string
		size?: Size
	}>(),
	{
		backgroundColor: 'darkGreen',
		size: 'md',
	}
)

// const top = ref(Math.floor(Math.random() * 3))
// const bottom = ref(Math.floor(Math.random() * 3))

const computedHeight = computed(() => {
	switch (props.size) {
		case 'sm':
			return 'h-8'
		case 'md':
			return 'h-20'
		case 'lg':
			return 'h-32'
		case 'xl':
			return 'h-40'
		default:
			return 'h-8'
	}
})

const selectedColor = computed(() => {
	return `bg-${props.backgroundColor}`
})
</script>

<style scoped>
.wave-top {
	position: absolute;
	top: -2px;
	left: 0;
	width: 100%;
	overflow: hidden;
	line-height: 0;
	transform: rotate(180deg);
}

.wave-top svg {
	position: relative;
	display: block;
	width: calc(185% + 1.3px);
	height: 124px;
	/* transform: rotateY(180deg); */
}

.wave-bottom {
	position: absolute;
	bottom: -2px;
	left: 0;
	width: 100%;
	overflow: hidden;
	line-height: 0;
	/* transform: rotate(180deg); */
}

.wave-bottom svg {
	position: relative;
	display: block;
	width: calc(100% + 1.3px);
	height: 70px;
	/* transform: rotate(180deg); */
}
</style>
